import moment from 'moment-timezone';
import logger from '../../../utils/logger';
import { toNumber } from '../../../utils/numbers';
import convertUnit from '../../../utils/unit-converter';
import { WeighedDataToBatch } from '../../../containers/Batch/DataToBatch';
import { Material } from '../../../../types/api/Material';
import { Device } from '../../../../types/api/Device';

// CONFIGURATION
const CHANGE_MATERIAL_MID_BATCH_CONFIG = {
  updateInventory: false,
};

export const updateInventoryIfEnabled = (
  materialStore: any,
  batchStore: any,
  originalMaterial: Material,
  substituteMaterial: Material,
  currentWeight: number,
  scale: Device,
  runningData: any,
  originalBin?: Device,
) => {
  if (currentWeight > 0 && batchStore.canReduceInventory && CHANGE_MATERIAL_MID_BATCH_CONFIG.updateInventory) {
    const originalQuantity = toNumber(convertUnit(currentWeight, batchStore.getUnitById(scale.unitId), originalMaterial.itemInventoryUnitSymbol || ''), 4);

    materialStore.updateMaterialInventoryUse(originalMaterial, {
      quantity: originalQuantity,
      comment: `Substituted with ${substituteMaterial.code}`,
      ticket: runningData.tId,
      isAutomatic: false,
      binIds: [ originalBin?.id ],
    });

    logger.log('Updated inventory for original material:', originalMaterial.code, originalQuantity);
  }
};

export const createSubstituteWeighedData = (
  scaleData: any,
  runningData: any,
  substituteMaterial: Material,
  substituteMaterialDetails: Material,
  substituteBin: Device,
  originalMaterial: Material,
  originalBin: Device,
  reason: string,
  currentWeight: number,
  currentScaleWeight: number,
  batchStore: any,
): WeighedDataToBatch => {
  const constituent = scaleData.constituent || runningData.mixDesign?.find((c: any) =>
    c.constituentItemId === originalMaterial.itemId ||
    (c.batchCode && originalMaterial.batchCode && c.batchCode === originalMaterial.batchCode),
  );

  return new WeighedDataToBatch({
    constituent: constituent ? {
      ...constituent,
      constituentItemId: substituteMaterial.itemId,
      constituentItemCode: substituteMaterial.code,
      batchCode: substituteMaterial.batchCode,
      batchShortDescription: substituteMaterial.batchShortDescription,
    } : null,
    material: substituteMaterial,
    materialDetails: substituteMaterialDetails,
    binPercent: scaleData.binPercent || {},
    bin: substituteBin,
    binForDecum: scaleData.binForDecum,
    scale: scaleData.scale,
    mft: scaleData.mft,
    unconvertedTarget: scaleData.unconvertedTarget,
    jogSecondary: scaleData.jogSecondary || false,
    jogCounter: scaleData.jogCounter || 0,
    originalMaterial: originalMaterial,
    originalBin: originalBin,
    substitutionReason: reason,
    substitutionWeight: currentWeight,
    substitutionTimestamp: moment().tz(batchStore.timezone).format(),
    isSubstituted: true,
    isFeedInterrupted: true,
    isFeedFinish: false,
    startWeight: currentScaleWeight,
    feedLogs: [],
  });
};
